import React from 'react';
import Icon from '@material-ui/core/Icon';

export interface HeaderIconProps {
  iconClassName?: string;
  icon: string;
  className?: string;
}

const HeaderIcon: React.FC<HeaderIconProps> = ({ iconClassName, icon, ...props }) => {
  return (
    <span {...props}>
      <Icon className={iconClassName} data-testid='header-icon--icon'>
        {icon}
      </Icon>
    </span>
  );
};

export default HeaderIcon;
